import { render } from "./apptitude-result.vue?vue&type=template&id=7d546c18"
import script from "./apptitude-result.vue?vue&type=script&lang=js"
export * from "./apptitude-result.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__